import { useEffect } from "react";
import { resourceDetailsAvailableTabsSelector } from "@/store/resource-details/selectors/options/resourceDetailsAvailableTabsSelector";
import { resourceDetailsTargetResourceIdSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceIdSelector";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { resourceDetailsOpenFromSelector } from "@/store/resource-details/selectors/options/resourceDetailsOpenFromSelector";
import { getAiKubernetesRecommendationsThunk } from "@/store/ai-kubernetes-recommendations/thunks/getAiKubernetesRecommendationsThunk";
import { k8SResourceDetailsTargetRecommendationIdSelector } from "@/store/resource-details/selectors/target-resource/k8SResourceDetailsTargetRecommendationIdSelector";
import { getSavingsOpportunityByResourceIdThunk } from "@/store/savings-opportunities/thunks/data-getters/getSavingsOpportunityByResourceIdThunk";
import { resourceDetailsTargetResourceProviderSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceProviderSelector";

export const useResourceDetailsOpportunities = () => {
  const dispatch = useAppDispatch();

  const resourceId = useAppSelector(resourceDetailsTargetResourceIdSelector);
  const aiRecommendationId = useAppSelector(
    k8SResourceDetailsTargetRecommendationIdSelector,
  );
  const provider = useAppSelector(
    resourceDetailsTargetResourceProviderSelector,
  );
  const availableTabs = useAppSelector(resourceDetailsAvailableTabsSelector);
  const open = useAppSelector(resourceDetailsOpenFromSelector);

  useEffect(() => {
    if (
      resourceId &&
      provider &&
      open &&
      availableTabs.includes("opportunities")
    ) {
      dispatch(
        getSavingsOpportunityByResourceIdThunk({ provider, resourceId }),
      );
    }
    if (
      aiRecommendationId &&
      open &&
      availableTabs.includes("ai-kubernetes-opportunities")
    ) {
      dispatch(getAiKubernetesRecommendationsThunk(aiRecommendationId));
    }
  }, [resourceId, dispatch, provider, availableTabs, open, aiRecommendationId]);
};
